import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * テキスト表示
 *【内容:text:string】
 *【表示条件:visible:boolean】
 *【スタイル適用条件:applyStyle:boolean】
 *【スタイルクラス名:className:string】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-text-display-field',
  templateUrl: './text-display-field.html',
  styles: [`
    .text-title-value {
      font-size: 20px;
      color: #1b1b1b;
    }
  `]
})
export class TextDisplayField extends BaseWidget {
  /**
   * 内容
   */
  @Input() text:string

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * スタイル適用条件
   */
  @Input() applyStyle:boolean

  /**
   * スタイルクラス名
   */
  @Input() className:string

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/text-display-field/text-display-field.component.ts